import { HANDLE_COMMIT_RESPONSE, type CommitResponseAction } from '../../issue/types.tsx';
import type { CommitResponse } from '../../commit/types.tsx';

type HandleCommitResponseFunc = (payload: CommitResponse) => CommitResponseAction;
type handleCommitResponseText = {
	text: Function;
};

export function isHandleCommitResponseMethod(
	res: HandleCommitResponseFunc | handleCommitResponseText,
): res is HandleCommitResponseFunc {
	return typeof res === 'function';
}

export const handleCommitResponse: HandleCommitResponseFunc | handleCommitResponseText = (
	payload,
) => ({
	type: HANDLE_COMMIT_RESPONSE,
	payload,
});
